// Read platform from the initial URL before SPA navigation can change it.
const _platform = new URLSearchParams(window.location.search).get('platform');

export const NATIVE_PLATFORM: 'android' | 'ios' | null =
  _platform === 'android' || _platform === 'ios' ? _platform : null;

export const IS_NATIVE = NATIVE_PLATFORM !== null;

export function postToNative(type: string, payload?: Record<string, unknown>): void {
  if (!IS_NATIVE) return;
  const message = JSON.stringify({ type, ...payload });

  const w = window as Window & {
    webkit?: { messageHandlers?: { bridge?: { postMessage: (m: string) => void } } };
    android?: { postMessage: (m: string) => void };
  };

  if (w.webkit?.messageHandlers?.bridge?.postMessage) {
    w.webkit.messageHandlers.bridge.postMessage(message);
  } else if (w.android?.postMessage) {
    w.android.postMessage(message);
  } else {
    window.postMessage(message, window.location.origin);
  }
}

export function onNativeMessage(
  type: string,
  handler: (payload: Record<string, unknown>) => void
): () => void {
  const listener = (event: MessageEvent) => {
    try {
      const data: unknown = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      if (
        data !== null &&
        typeof data === 'object' &&
        (data as Record<string, unknown>).type === type
      ) {
        handler(data as Record<string, unknown>);
      }
    } catch {
      // ignore malformed messages
    }
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
